export default{
  CAP_TABLE_TASKS:{
    TASK_OPTION_PLANS_OPTION_GRANTS_ADD:'option plans and option grants',
    TASK_OPTION_PLAN_ADD:'option plans and option grants',
    TASK_CONVERTIBLES_ADD:'convertibles',
    TASK_WARRANTS_ADD:'warrants',
  }
}